






























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class StandartTable extends Vue {
  @Prop({ type: Array, default: () => [] }) rows!: Array<unknown>;
  @Prop({ type: Number, default: 1 }) colspan!: number;
  @Prop({ type: String, default: "" }) empty!: string;
  @Prop({ type: Boolean, default: false }) open!: boolean;

  get showEmpty(): boolean {
    return !this.rows.length && (!!this.empty || !!this.$slots.empty);
  }
}
